module.exports = __webpack_public_path__ + "img/Apoptosis-BRCA_10X_Section2.aec5c455.png";